export const LIST = "BONUS_LIST";
export const APPLY_RESCUE_BONUS = "BONUS_APPLY_RESCUE_BONUS";
export const CLAIM_FIRST_BET_BONUS = "CLAIM_FIRST_BET_BONUS";
export const REDEEM_VOUCHER_CODE = "REDEEM_VOUCHER_CODE";
export const APPLY_DELAY_BONUS = "APPLY_DELAY_BONUS";